var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"sidebar-menu-icon",attrs:{"src":`/image/${_vm.active ? _vm.activeIcon : _vm.icon}`,"alt":"icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }